import React from 'react';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import TranslateField from 'components/common/fields/TranslateField';
import { notEmpty } from 'utils/ramdaAdditions';

const ApprovalComments = ({ comments }) => notEmpty(comments) ? (
    <div>
        <DefinitionHeader translate='project.headers.comments' iconType='comment' />
        <div className='panel-view'>
            { comments.map((comment, index) => (
                <div className='text-pre-space' key={index}>
                    <b><TranslateField ru={comment.personName || comment.peopleName} en={comment.peopleNameEngl} /></b> &mdash; <span>{comment.comment}</span>
                </div>
            ))}
        </div>
    </div>
) : null;

export default ApprovalComments;
